export default __webpack_public_path__ + "static/media/danai.8ad5889e.png";